import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import ImageUpload from '../components/ImageUpload';
import Logo from '../postit_200x200.png';
import { BsPersonFill } from 'react-icons/bs';
import "../App.css";

function Header() {
  const [username] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
        if (authUser) {
            console.log(authUser);
            setUser(authUser);

        } else {
            setUser(null);
        }

        return () => {
          unsubscribe();
        }
        
        
    })
  }, [user, username]);


  return (
    <header className="navbar navbar-expand-lg navbar-light shadow-sm p-3 sticky-top justify-content-around align-items-center">
      {user?.displayName ? (
      <ImageUpload username={user.displayName}/>
      ): (
       <p>Login to upload</p>
        )

      }
      
      <Link to='/'>
      <img
      className="logo"
        src={Logo}
        alt="logo"
      />
      </Link>

      <Link to='/profile'>
      <BsPersonFill size={30} className="text-dark"/>
      </Link>
      

        
    </header>
  );
}

export default Header;
